var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSent = function SvgSent(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.288 35.288",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.118 10.537a2.7 2.7 0 0 0-1.265-.316H10.806a2.7 2.7 0 0 0-1.266.316l9.288 6.192Zm0 0",
    className: "sent_svg__superlight",
    "data-name": "Pfad 536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.546 22.305v-9.39a2.67 2.67 0 0 0-.355-1.334l-9.956 6.638a.73.73 0 0 1-.813.001l-9.956-6.638a2.7 2.7 0 0 0-.354 1.333v.825H4.175a.733.733 0 0 0 0 1.464h3.938v1.673h-7.07a.733.733 0 1 0-.007 1.465h7.071v1.673H4.174a.732.732 0 1 0-.001 1.465l3.942-.004v.825a2.7 2.7 0 0 0 2.693 2.693l16.045.004a2.7 2.7 0 0 0 2.693-2.693m0 0",
    "data-name": "Pfad 537"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSent);
export default ForwardRef;